export const CYCLE_SECONDS = 12;
export function previewFrame(seconds) {
  const t = ((seconds % CYCLE_SECONDS) + CYCLE_SECONDS) % CYCLE_SECONDS;
  if (t < 2) return { pose: 'idle', lift: 0, lean: 0, spin: 0 };
  if (t < 4) return { pose: 'carve_left', lift: 0, lean: Math.sin((t - 2) / 2 * Math.PI) * .17, spin: 0 };
  if (t < 6) return { pose: 'carve_right', lift: 0, lean: -Math.sin((t - 4) / 2 * Math.PI) * .17, spin: 0 };
  if (t < 6.8) return { pose: 'charge', lift: 0, lean: 0, spin: 0 };
  if (t < 9.2) {
    const p = (t - 6.8) / 2.4;
    return { pose: p < .17 ? 'air' : p > .84 ? 'air' : 'trick', lift: 1.7 * Math.sin(p * Math.PI), lean: 0, spin: 0 };
  }
  return { pose: t < 10.2 ? 'land' : 'idle', lift: 0, lean: 0, spin: 0 };
}
export function smooth(current, target, rate, dt) {
  return current + (target - current) * (1 - Math.exp(-rate * Math.max(0, dt)));
}

export class PreviewClock {
  time = 0;
  paused = false;
  advance(dt) {
    if (this.paused || !Number.isFinite(dt) || dt < 0) return false;
    if (dt > .25) { this.paused = true; return false; }
    this.time += dt;
    return true;
  }
  reset() { this.time = 0; this.paused = false; }
}
